/**
 * dialogタグを利用したモーダル
 * @constructor
 * @author ERINA MORISAKI
 */
class Dialog {
  /**
   * @param {string} this._addClassNameVal 付与するクラス名。
   * @param {string} this._triggerClassName モーダルを開くボタンのクラス名。
   * @param {string} this._targetClassName 開かれるモーダルのクラス名。
   * @param {string} this._dialogContentClassName モーダルのコンテンツのクラス名。
   * @param {string} this._dialogCloseButtonClassName モーダル内の閉じるボタンのクラス名。
   */
  constructor() {
    this._addClassNameVal = 'is-open';
    this._triggerClassName = '.js-dialog-trigger';
    this._targetClassName = '.js-dialog-target';
    this._dialogContentClassName = '.js-dialog-contents';
    this._dialogCloseButtonClassName = '.js-dialog-close';
    this.init();
  }
  init() {
    if (document.querySelector(this._triggerClassName) != null) {
      this.dialog();
    }
  }

  dialog() {
    const triggerElemets = document.querySelectorAll(this._triggerClassName);
    const targetElements = document.querySelectorAll(this._targetClassName);
    const dialogContents = document.querySelectorAll(this._dialogContentClassName);
    const dialogCloseButtons = document.querySelectorAll(this._dialogCloseButtonClassName);
    const body = document.body;

    //モーダルを開く処理
    triggerElemets.forEach(triggerElemet => {
      triggerElemet.addEventListener('click', () => {
        targetElements.forEach(targetElement => {
          if(triggerElemet.dataset.modal == targetElement.dataset.modal) {
            targetElement.showModal();
          }

          //モーダルの背景をクリックしたときの処理
          targetElement.addEventListener('click', () => {
            targetElement.close();
            body.removeAttribute('style');
          });

        });

        //ページがスクロールしないための処理
        body.style.overflow = 'hidden';
      });
    });

    //閉じるボタンをクリックしたときの処理
    dialogCloseButtons.forEach(dialogCloseButton => {
      dialogCloseButton.addEventListener('click', () => {
        targetElements.forEach(targetElement => {
          targetElement.close();
        });
        body.removeAttribute('style');
      });
    });

    //Escキーを押したときの処理
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        body.removeAttribute('style');
      }
    });

    //コンテンツエリアはクリックしても閉じないようにする処理
    dialogContents.forEach(dialogContent => {
      dialogContent.addEventListener('click', event => {
        event.stopPropagation();
      }, false);
    });

  }
}

export default Dialog;
